import type {
  TestInfoEndElementValue,
  TestInfoStartElementValue,
} from '@vedalib/editor/lib/elements'

import { OPTIONS } from './TestInfoElement.constants'
import type { PageItem } from './testInfoTypes'

const getTextInfoAppearance = (
  item: PageItem,
  value: TestInfoStartElementValue | TestInfoEndElementValue,
) => {
  const options = OPTIONS[item]
  const valueConfig = value[options.name]

  return {
    ...options,
    ...valueConfig,
  }
}

export { getTextInfoAppearance }
